import { Box, Typography } from '@mui/material';
import SectionBar from './SectionBar';
import {
  PRINT_FONT_SIZE,
  PRINT_REMARKS_HEIGHT,
  PRINT_REMARKS_MAX_LINES,
  cellPaddingSx,
} from './printStyles';

interface RemarksSectionProps {
  remarks: string;
}

const RemarksSection = ({ remarks }: RemarksSectionProps) => (
  <Box
    sx={{
      display: 'flex',
      flexDirection: 'column',
      height: PRINT_REMARKS_HEIGHT,
    }}
  >
    <SectionBar title="Remarks / Special Instructions" />
    <Box sx={{ ...cellPaddingSx, flex: 1, minHeight: 0, overflow: 'hidden' }}>
      <Typography
        color="error"
        sx={{
          fontSize: PRINT_FONT_SIZE.remarks,
          fontWeight: 600,
          lineHeight: 1.2,
          whiteSpace: 'pre-line',
          overflow: 'hidden',
          display: '-webkit-box',
          WebkitLineClamp: PRINT_REMARKS_MAX_LINES,
          WebkitBoxOrient: 'vertical',
        }}
      >
        {remarks}
      </Typography>
    </Box>
  </Box>
);

export default RemarksSection;
